import { RequestService, type RequestOptions } from '../request-service';
import type {
  QueryPremiumAssetsRequest,
  QueryPremiumAssetsResponse,
} from '@wix/ambassador-premium-asset-v2-premium-asset/types';
import type RpcModule from '@wix/ambassador-premium-asset-v2-premium-asset/rpc';
import type HttpModule from '@wix/ambassador-premium-asset-v2-premium-asset/http';
import { PremiumAssets } from './premium-assets';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class PremiumAssetsService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-premium-asset-v2-premium-asset/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-premium-asset-v2-premium-asset/http');
  }

  public async query(
    {
      metaSiteId,
      productTypeId,
    }: {
      metaSiteId: string;
      productTypeId: string;
    },
    options?: RequestOptions,
  ) {
    const response = await this.request<
      QueryPremiumAssetsRequest,
      QueryPremiumAssetsResponse
    >({
      methodName: 'queryPremiumAssets',
      payload: {
        query: {
          filter: {
            'productData.productTypeId': productTypeId,
            'siteData.metasiteId': metaSiteId,
          },
        },
      },
      options,
    });
    return new PremiumAssets(response.premiumAssets ?? []);
  }
}
